import { publicConfig } from '@/config/publicConfig'

export const APP_VARIANT_DEFAULT = 'default'
export const APP_VARIANT_BONDSCAN = 'bondscan'
export const APP_VARIANT_BONDEXPLORER = 'bondexplorer'

export const isBondscanVariant = publicConfig.app.variant === APP_VARIANT_BONDSCAN
export const isBondexplorerVariant = publicConfig.app.variant === APP_VARIANT_BONDEXPLORER
export const isExplorerOnlyVariant = isBondscanVariant || isBondexplorerVariant
